import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractCommand from "../../app/core/AbstractCommand";
import PlatformAPIEventType from "../platform/PlatformAPIEventType";
import BaseSaveModel from "./BaseSaveModel";
import SaveEvent from "./SaveEvent";

export default class SaveCommand extends AbstractCommand {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {BaseSaveModel} saveModel 
     */
    constructor(dispatcher, saveModel) {
        super(dispatcher);

        this.execute = function({ type }) {
            let stateObj;
            switch (type) {
                case SaveEvent.SAVE:
                    stateObj = saveModel.createSaveGame();
                    // console.log("SaveCommand::SAVE: ", stateObj);
                    if (getURLParameter("dontsave") != "1") {
                        this.dispatch(PlatformAPIEventType.SAVE_REQUEST, { state: stateObj });
                    }
                    break;
                case SaveEvent.CLEAR:
                    stateObj = null;
                    this.dispatch(PlatformAPIEventType.SAVE_REQUEST, { state: stateObj });
                    break;
            }
            this.dispatch(SaveEvent.SAVED);
        }
    }
}
